import { Controller } from "stimulus";

export default class extends Controller {
  formErrorHandler(e) {
    const section = e.target.closest("section");
    section.outerHTML = e.detail[2].responseText;
  }

  toggleSection(e) {
    e.preventDefault();

    const section = e.currentTarget.closest("section");
    const table = section.querySelector("table");
    const form = section.querySelector("form");

    table.classList.toggle("d-none");
    form.classList.toggle("d-none");
  }
}
